import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import SEO from "@/components/app/SEO";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// This page handles the redirect from https://auth.emergentagent.com/
// The provider appends #session_id=<id> to the redirect URL fragment.
export default function AuthCallbackPage() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      toast.error("Session Google introuvable");
      nav("/connexion", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        localStorage.setItem("re_token", data.access_token);
        setUser(data.user);
        // Clean the URL fragment for security
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Bienvenue ${data.user.first_name || data.user.email}`);
        if (data.user.role === "admin") nav("/admin", { replace: true });
        else if (data.user.role === "broker") nav("/courtier", { replace: true });
        else nav("/espace", { replace: true });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Connexion Google échouée";
        toast.error(msg);
        nav("/connexion", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <SEO title="Connexion Google en cours" canonical="/auth/callback" noindex />
      <div className="text-center max-w-md">
        <div className="mx-auto mb-4 h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
        <h1 className="text-xl font-semibold mb-1">Finalisation de la connexion Google…</h1>
        <p className="text-sm text-muted-foreground">Nous récupérons vos informations en toute sécurité.</p>
      </div>
    </div>
  );
}
